var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nav-tabs-wrapper bb-0" }, [
    _c(
      "ul",
      { staticClass: "nav nav-tabs p-0", attrs: { role: "tablist" } },
      _vm._l(_vm.tabs, function (tab) {
        return _c(
          "li",
          {
            key: tab.value,
            staticClass: "nav-item",
            class: _vm.currentTab === tab.value ? "navbar-active active" : "",
          },
          [
            _c(
              "div",
              {
                staticClass: "nav-link clickable",
                attrs: {
                  role: "tab",
                  "aria-controls": "create",
                  "aria-selected": "false",
                },
                on: {
                  click: function ($event) {
                    return _vm.handleTabChange(tab.value)
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(tab.label) + "\n      ")]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }